export const NONE = -1
export const ADVANCE_LIST_STEP = 0
export const INVOICE_FORM_STEP = 1
export const FILE_UPLOAD_STEP = 2
